<template>
  <div
    :class="[colorClasses[color], sizeClasses[size]]"
    class="flex items-center gap-1 w-fit rounded border font-medium text-textPrimary"
  >
    <svg
      v-if="icon"
      xmlns="http://www.w3.org/2000/svg"
      :class="[iconSizeClasses[size], iconColorClasses[color]]"
      viewBox="0 0 24 24"
    >
      <path :d="icon" fill="currentColor" />
    </svg>
    {{ label }}
  </div>
</template>

<script setup lang="ts">
import { mdiAlertCircleOutline } from '@mdi/js'

export type LabelBadgeColor = 'blue' | 'orange' | 'green' | 'yellow' | 'red' | 'gray' | 'purple'
export type LabelBadgeSize = 'small' | 'medium'

withDefaults(
  defineProps<{
    label: string
    color?: LabelBadgeColor
    size?: LabelBadgeSize
    icon?: string | null
  }>(),
  {
    color: 'blue',
    size: 'medium',
    icon: mdiAlertCircleOutline
  }
)

const colorClasses: Record<LabelBadgeColor, string> = {
  blue: 'border-primary bg-primary5',
  orange: 'border-alert bg-orange-50',
  green: 'border-sucess bg-green-50',
  yellow: 'border-warning bg-yellow-50',
  red: 'border-negative bg-red-50',
  gray: 'border-gray-300 bg-gray-100',
  purple: 'border-purple-300 bg-purple-50'
}

const iconColorClasses: Record<LabelBadgeColor, string> = {
  blue: 'text-primary',
  orange: 'text-alert',
  green: 'text-sucess',
  yellow: 'text-warning',
  red: 'text-negative',
  gray: 'text-neutral50',
  purple: 'text-purple-700'
}

const sizeClasses: Record<LabelBadgeSize, string> = {
  small: 'text-xs px-2 py-0.5',
  medium: 'text-sm px-2.5 py-1'
}

const iconSizeClasses: Record<LabelBadgeSize, string> = {
  small: 'w-3.5 h-3.5',
  medium: 'w-4 h-4'
}
</script>
